import React from "react";
import { Link } from "react-router-dom";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
// import Favorite from "@material-ui/icons/Favorite";
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import FooterLinks from "components/Footer/FooterLinks.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import { HashLink } from 'react-router-hash-link';

import landingPageStyle from "assets/jss/material-kit-pro-react/views/landingPageStyle.jsx";

// Consent
import CookieConsent, { Cookies } from "react-cookie-consent";

// Sections for this page
import SectionProduct from "./Sections/SectionProduct.jsx";
import SectionWork from "./Sections/SectionWork.jsx";
import SectionPricing from "./Sections/SectionPricing.jsx";
// Footer
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

class LandingPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          color="transparent"
          brand="Kinos Corp"
          links={<HeaderLinks dropdownHoverColor="info" />}
          fixed
          changeColorOnScroll={{
            height: 300,
            color: "info"
          }}
          {...rest}
        />
      <Parallax image={require("assets/img/Kinos/home.jpeg")} filter="dark">
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6}>
                <h1 className={classes.title}>Commercial and residencial Real Estate</h1>
                <h4>
                  Connecting investors with opportunities to Investment.
    Managing real estate family or business assets
                </h4>
                <br />
                <Link to="/offer" className={classes.dropdownLink}>
                  <Button
                    color="danger"
                    size="lg"
                  >
                    <i className="fas fa-play" />
                    Explore our offer opportunities
                  </Button>
                </Link>
                <Link to="/demand" className={classes.dropdownLink}>
                  <Button
                    color="danger"
                    size="lg"
                  >
                    <i className="fas fa-play" />
                      Explore our demand of assets
                  </Button>
                  </Link>
              </GridItem>
              <GridItem
                  md={12}
                  sm={12}
                  className={classNames(
                    classes.mlAuto,
                    classes.mrAuto,
                    classes.textCenter
                  )}
              >

                <HashLink to="/properties#retail" smooth><Button color="rose" size="sm" round>RETAIL</Button></HashLink>
                <HashLink to="/properties#industrial" smooth><Button color="rose" size="sm" round>INDUSTRIAL</Button></HashLink>
                <HashLink to="/properties#offices" smooth><Button color="rose" size="sm" round>OFFICES</Button></HashLink>
                <HashLink to="/properties#buildings" smooth><Button color="rose" size="sm" round>BUILDINGS</Button></HashLink>
                <HashLink to="/properties#hotels" smooth><Button color="rose" size="sm" round>HOTELS</Button></HashLink>
                <HashLink to="/properties#malls" smooth><Button color="rose" size="sm" round>SHOPPING CENTERS & MALLS</Button></HashLink>
                <HashLink to="/properties#residential" smooth><Button color="rose" size="sm" round>RESIDENTIAL</Button></HashLink>
                <HashLink to="/properties#n_d" smooth><Button color="rose" size="sm" round>NEW DEVELOPMENTS</Button></HashLink>
                <HashLink to="/properties#lands" smooth><Button color="rose" size="sm" round>URBAN LANDS</Button></HashLink>
                <HashLink to="/properties#rural_lands" smooth><Button color="rose" size="sm" round>RURAL LANDS</Button></HashLink>
                <HashLink to="/properties#investments" smooth><Button color="rose" size="sm" round>INVESTMENTS</Button></HashLink>
                <HashLink to="/properties#ops" smooth><Button color="rose" size="sm" round>BUSINESS OPORTUNITIES</Button></HashLink>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>

            <SectionProduct />
            <SectionPricing />

            <SectionWork />
          </div>
        </div>

        <br></br><br></br>

        <Footer>
          <FooterLinks/>
        </Footer>
        <CookieConsent location="bottom" cookieName="AcceptCookie" expires={999} overlay>
          This website uses cookies to enhance the user experience.
        </CookieConsent>
      </div>
    );
  }
}

export default withStyles(landingPageStyle)(LandingPage);
